
// 当前前台是否为开发模式
const isDev = process.env.NODE_ENV === 'development1'
let adminUrl = isDev ? 'http://192.168.0.154' : 'https://mtest.bjftyx.net/sys'
let adminApiUrl = isDev ? 'http://192.168.0.154:8082' : 'https://explicit-crown-rust.ngrok-free.dev/api'
switch (process.env.VUE_APP_APP_HOST) {
	case 'development'://测试
		adminUrl = 'https://mtest.bjftyx.net/sys'
		adminApiUrl = 'https://mtest.bjftyx.net/admin-api'
		break
	case 'production'://正式
		adminUrl = 'https://m.bjftyx.net/sys'
		adminApiUrl = 'https://m.bjftyx.net/admin-api'
		break
}
export default {
	pageSize: 10,
	// adminUrl: isDev ? 'http://192.168.0.213' : 'https://m.bjftyx.net/sys',
	// adminApiUrl: isDev ? 'http://192.168.0.213:8082' : 'https://m.bjftyx.net/admin-api',

	adminUrl: adminUrl,
	adminApiUrl: adminApiUrl,
	isDev: true,
}
